// extracted by mini-css-extract-plugin
module.exports = {"text":"ContactButton_text__19oL-","button":"ContactButton_button__3bFwO"};